/**
 * Query key factory for allocations
 */

export const allocationKeys = {
  all: ['allocations'] as const,
  details: () => [...allocationKeys.all, 'detail'] as const,
  detail: (id: string) => [...allocationKeys.details(), id] as const,
};
